import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

/**
 * Component that removes trailing slashes from URLs to prevent 404 errors on refresh
 * This handles the client-side routing while Amplify handles server-side redirects
 */
export function TrailingSlashRedirect() {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const { pathname, search, hash } = location

    // Check if the pathname has a trailing slash (but not for root path)
    if (pathname !== '/' && pathname.endsWith('/')) {
      // Remove the trailing slash and navigate to the new path
      const newPath = pathname.slice(0, -1) + search + hash
      navigate(newPath, { replace: true })
    }
  }, [location, navigate])

  return null
}